import { render, staticRenderFns } from "./DingTalkDeptSelect.vue?vue&type=template&id=88d319d6&scoped=true"
import script from "./DingTalkDeptSelect.vue?vue&type=script&lang=js"
export * from "./DingTalkDeptSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d319d6",
  null
  
)

export default component.exports